import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

import type { MethodGroupPayloadType } from "@/common/types/method/method-group";

export async function methodGroupList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/method/list${queryString}`,
  );
}

export async function methodGroupCreate(
  account_id: string,
  payload: MethodGroupPayloadType,
) {
  return await clientAxios.post(`account/${account_id}/method/create`, payload);
}

export async function methodGroupShow(account_id: string, group_id: string) {
  return await clientAxios.get(`account/${account_id}/method/${group_id}/show`);
}

export async function methodGroupUpdate(
  account_id: string,
  group_id: string,
  payload: MethodGroupPayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/method/${group_id}/update`,
    payload,
  );
}

export async function methodGroupDelete(account_id: string, group_id: string) {
  return await clientAxios.del(
    `account/${account_id}/method/${group_id}/delete`,
  );
}
